export enum USER_ROLE {
  USER = 'user',
  ADMIN = 'admin'
}
